export const checklist_remark = {
  checklist: 'Checklist',
  address: 'Adresse',
  returnButton: 'Retour vers la Checklist',
  generalRemarkLabel: 'Remarques générales pour le bâtiment',
  themeRemarkLabel: 'Remarques générales pour thème',
};
